// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { subQuarters as fn } from "../subQuarters.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const subQuartersWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default subQuartersWithOptions;
